var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trial-period-header"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.$t('trial-period-rest', {
                trialPeriod: _vm.$t(("months." + _vm.getInitialTrialPeriod)),
                trialPeriodRestDays: _vm.getTrialPeriod,
            }))+"\n        "),_c('span',{staticClass:"click-here",domProps:{"textContent":_vm._s(_vm.$t('click-here'))},on:{"click":_vm.navigateToBilling}})])])}
var staticRenderFns = []

export { render, staticRenderFns }